module.exports = __webpack_public_path__ + "img/login-rwm.9bd7123f.png";